<template>
  <div class="txl-upload-public-file" @click.stop="triggerSelectFile">
    <input
      type="file"
      class="txl-upload-public-file-input"
      ref="txlInputFile"
      :multiple="multiple"
      :accept="accept"
      :beforeUploadValidator="beforeUploadValidator"
      @change="uploadFile">
    <slot></slot>
  </div>
</template>

<script>
import OSS from 'ali-oss'
import { v4 as uuid } from 'uuid'
import { getOssSecurityToken } from '@/apis/uploadFile'

export default {
  name: 'UploadPublicFile',
  data() {
    return {}
  },
  props: {
    isImage: {
      type: Boolean,
      default: true
    },
    appName: {
      type: String,
      default: 'workbench'
    },
    accept: {
      type: String,
      default: ''
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    // 文件最大大小，单位byte
    fileMaxSize: {
      type: Number,
      default: 100 * 1024 * 1024 // 100M
    },
    // 上传前校验 返回boolean值
    beforeUploadValidator: {
      type: Function,
      default: function() {
        return true
      }
    }
  },
  mounted() {},
  methods: {
    triggerSelectFile() {
      const inputFile = this.$refs.txlInputFile
      if (inputFile) {
        inputFile.click()
      }
    },
    async uploadFile(e) {
      const file = e.target.files[0]
      if (file.size > this.fileMaxSize) {
        const message = `文件大小不能超过 ${this.fileMaxSize} byte`
        console.error(message)
        this.$emit('on-error', {
          message,
          file: file
        })
        return
      }
      // 上传前置校验
      const isValid = await this.beforeUploadValidator(file)
      if (!isValid) {
        console.error('文件上传校验失败')
        this.$emit('on-error', {
          message: '文件上传校验失败',
          file: file
        })
        return
      }
      // 获取oss client
      const ossClient = await this.getOssClient()
      if (ossClient) {
        file.fileRealName = file.name
        file.fileSize = file.size * 1
        file.startTime = new Date()
        const ext = file.name.substring(file.name.lastIndexOf('.') + 1)
        file.fileType = ext
        const objectName = `${this.appName}/${uuid()}.${ext}`
        let ossResult = null
        if (this.isImage) {
          // 上传图片 可以直接预览
          ossResult = await ossClient.put(objectName, file)
        } else {
          // 上传文件 需要分片上传 并且支持下载
          ossResult = await ossClient.multipartUpload(objectName, file, {
            partSize: 1024 * 1024, // 分片1M
            headers: {
              'Content-Disposition': `attachment; filename=${encodeURIComponent(file.fileRealName)}`,
              'Content-Type': 'application/octet-stream'
            },
            progress: (p) => { // 支持进度
              file.percentage = Math.floor(p * 100)
              file.successSize = file.fileSize * p
              if (file.successSize === 0) {
                file.speed = null
                file.remainingTime = null
              } else {
                const speed = file.successSize / ((new Date().getTime() - file.startTime.getTime()) / 1000)
                file.speed = speed === Infinity ? 0 : speed // 单位b/s
                file.remainingTime = ((file.fileSize / file.speed) - (file.successSize / file.speed)).toFixed(0) // 单位秒
              }
              this.$emit('on-progress', file)
            },
          })
          ossResult.url = ossResult.res.requestUrls[0]
        }
        this.$emit('on-success', {
          message: 'success',
          file: file,
          data: ossResult
        })
      } else {
        console.error('获取oss信息失败')
        this.$emit('on-error', {
          message: '获取oss信息失败',
          file: file
        })
      }
    },
    getOssClient() {
      return getOssSecurityToken().then(res => {
        if (res.code === '0') {
          const data = res.data
          const ossClient = new OSS({
              region: data.region,
              bucket: data.bucketName,
              accessKeyId: data.accessKeyId,
              accessKeySecret: data.accessKeySecret,
              stsToken: data.securityToken
          })
          return ossClient
        }
        return null
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.txl-upload-public-file-input {
  display: none;
}
</style>
